module.exports = __webpack_public_path__ + "img/status-delivery.a7e8014e.svg";